var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_vm._v("\n  자주 묻는 질문\n  "),_c('b-card',{staticClass:"bs-callout bs-callout-primary panelScrollBar",staticStyle:{"height":"500px"}},[_c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185b3f0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/management/board/QA.vue
// module id = null
// module chunks = 